import { render } from "./PlaylistAudioFeatures.vue?vue&type=template&id=f20d6076"
import script from "./PlaylistAudioFeatures.vue?vue&type=script&lang=js"
export * from "./PlaylistAudioFeatures.vue?vue&type=script&lang=js"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__